<template>
  <ion-grid
    class="home-section-container ion-padding-horizontal ion-margin-horizontal"
  >
    <ion-row>
      <ion-col size="12" size-lg="6" class="ion-text-center">
        <ion-chip
          color="primary"
          class="ion-display-inline-flex ion-justify-content-evenly"
        >
          <ion-icon :icon="flashOutline" aria-hidden="true"></ion-icon>
          <div>Fantasy Sports meets Wikipedia</div>
        </ion-chip>
        <h1 class="ion-text-center">
          Build Your <strong>Knowledge Empire</strong>
        </h1>
        <p class="ion-padding-horizontal ion-text-center">
          Draft Wikipedia articles, earn points from real search trends, and
          compete in weekly tournaments. The ultimate fantasy game for the
          curious mind.
        </p>
        <ion-button
          class="ion-text-capitalize ion-padding-horizontal"
          size="large"
        >
          <ion-text>Get Started</ion-text>
          <ion-icon slot="end" :icon="arrowForwardOutline"></ion-icon>
        </ion-button>
        <p class="ion-text-center">
          Start with 1,000 credits • No credit card required
        </p>
        <app-stats></app-stats>
      </ion-col>
      <ion-col size="12" size-lg="6" class="ion-no-padding">
        <article-leaderboard
          @volume-resolved="handleVolumeResolved"
        ></article-leaderboard>
        <ion-chip class="top-right animate-float">📡 Live data</ion-chip>
        <ion-chip class="bottom-left animate-float"
          >📊 {{ todayVolumeLabel }}</ion-chip
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</template>

<script setup lang="ts">
import { ref } from "vue";
import {
  IonButton,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
  IonChip,
  IonText,
} from "@ionic/vue";
import { arrowForwardOutline, flashOutline } from "ionicons/icons";
import AppStats from "./AppStats.vue";
import ArticleLeaderboard from "./ArticleLeaderboard.vue";

const compactVolumeFormatter = new Intl.NumberFormat("en", {
  notation: "compact",
  maximumFractionDigits: 1,
});

function formatTodayVolumeLabel(volume: number): string {
  return `Over ${compactVolumeFormatter.format(volume)} views today`;
}

const todayVolumeLabel = ref(formatTodayVolumeLabel(2_000_000));

function handleVolumeResolved(volume: number): void {
  todayVolumeLabel.value = formatTodayVolumeLabel(volume);
}
</script>

<style scoped src="src/components/homePage/home-page.css"></style>
<style scoped>
ion-chip.top-right {
  position: absolute;
  top: -1rem;
  right: -1rem;
  --background: var(--ion-color-wiki-gold);
  --color: var(--ion-color-dark);
}

:root .ion-palette-dark ion-chip.top-right {
  --color: var(--ion-color-light);
}

ion-chip.bottom-left {
  position: absolute;
  bottom: -1rem;
  left: -1rem;
  --background: var(--ion-color-primary);
  --color: var(--ion-color-light);
}

ion-chip.animate-float {
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}
</style>
